<template>
  <div class="w-100 h-100">
    <iframe
      v-if="sessionReplayUri"
      class="w-100 border-0 overflow-hidden"
      referrerpolicy="origin-when-cross-origin"
      allowfullscreen
      :src="sessionReplayUri"
      ref="sessionReplayer"
      height="705"
      scrolling="no"
    ></iframe>
    <div v-else>Oops, something went wrong!</div>
  </div>
</template>

<script>
export default {
  name: 'SessionReplayer',
  components: {},
  props: {
    sessionHash: { type: String },
  },
  data () {
    return {}
  },
  computed: {
    sessionReplayUri () {
      if (!this.sessionHash) return null
      return process.env.VUE_APP_REKOR_API + '/replay?session=' + encodeURIComponent(this.$root.client.client_code + '/' + this.sessionHash)
    }
  },
  async mounted () {
    window.setTimeout(() => {
      this.$refs.sessionReplayer.height = window.getComputedStyle(this.$refs.sessionReplayer.parentElement).height
    }, 250)
  },
  methods: {
    previous () {
      this.$emit('previous')
    },
    next () {
      this.$emit('next')
    }
  },
  watch: {}
}
</script>
